<template>
  <v-container fluid >
    <user-invitation-dialog
      :invitation-dialog="invitationDialog"
      @close-dialog="invitationDialog = false"
      @invite-user="inviteAdminUser"
    />
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">管理者一覧</h2>
        <permission-guard situation="admin_management">
          <v-btn color="primary" dark tile @click="invitationDialog = true">
            新規管理者ユーザー追加
          </v-btn>
          <UserIndexTable :users="adminUsers" :admin-table="true" @reinvite-user-auth="reinviteUserAuth" />
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import UserInvitationDialog from '@/components/commons/UserInvitationDialog'
import PermissionGuard from '@/components/commons/PermissionGuard'
import UserIndexTable from '@/components/commons/UserIndexTable'
import headUtilsMixin from '@/mixins/head_utils'
import { mapState } from 'vuex'
import { deserialize } from 'deserialize-json-api'

export default {
  components: {
    UserInvitationDialog,
    PermissionGuard,
    UserIndexTable
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '管理ユーザー一覧',
      page: 1,
      invitationDialog: false,
      adminUsers: []
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  mounted: function () {
    this.fetchAdminUsers()
  },
  methods: {
    fetchAdminUsers () {
      axios.get('/api/admin_users').then(
        ({ data }) => {
          this.adminUsers = deserialize(data).data
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    inviteAdminUser (address) {
      const query = {
        email: address
      }
      this.$store.dispatch('LoaderStore/displayLoader')
      axios.post('/api/admin_users/invitations', query).then(
        () => {
          this.fetchAdminUsers()
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: 200,
            message: '招待メールを送信しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
      this.invitationDialog = false
    },
    reinviteUserAuth (userAuthId) {
      if (!confirm('招待メールを送信してよろしいでしょうか？')) return

      axios.patch(`/api/admin_users/${userAuthId}/invitations`).then(
        () => {
          const payload = {
            status: 200,
            message: '招待メールを送信しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>
